export default function areNodesInDocumentOrder(nodeA: Node, nodeB: Node): boolean {
  return nodeA.compareDocumentPosition(nodeB) === Node.DOCUMENT_POSITION_FOLLOWING;
}
